// LocalStorageService.js
const LocalStorageService = (function () {
  var _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }

    return _service;
  }

  function _setToken(tokenObj) {
    localStorage.setItem("access_token", tokenObj.access);
    localStorage.setItem("refresh_token", tokenObj.refresh);
  }
  function _setAccessToken(token) {
    localStorage.setItem("access_token", token);
  }
  function getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
  function setUser(userObj) {
    localStorage.setItem("user", JSON.stringify(userObj));
  }

  function getAccessToken() {
    return localStorage.getItem("access_token");
  }

  function _getXbsToken() {
    return localStorage.getItem("xbs_token");
  }

  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }

  return {
    getService: _getService,
    getXbsToken: _getXbsToken,
    setToken: _setToken,
    setAccessToken: _setAccessToken,
    setUser,
    getUser,
    getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
  };
})();

export default LocalStorageService;
